import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fcf9b67"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex center top" }
const _hoisted_2 = { class: "text_number" }
const _hoisted_3 = { class: "flex center" }

import { withDefaults, ref, watch } from 'vue';
import { Modal, Select } from 'ant-design-vue';
import emitter from '@/utils/mitt';
interface Props {
  visible: boolean;
  centered?: boolean;
  closable?: boolean;
  footer?: null;
  ok: (...args: any[]) => any;
  close: (...args: any[]) => any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CAddCategory',
  props: {
    visible: { type: Boolean, default: false },
    centered: { type: Boolean, default: false },
    closable: { type: Boolean, default: true },
    footer: null,
    ok: null,
    close: null
  },
  setup(__props: any) {

const props = __props as { visible: boolean, centered: boolean, closable: boolean, footer?: null, ok: (...args: any[]) => any, close: (...args: any[]) => any };

const aModal = Modal;
const aSelect = Select;
const aSelectOption = Select.Option;


const options = ref([
  {
    value: 1,
    label: '文章',
  },
  {
    value: 2,
    label: '图片',
  },
  {
    value: 3,
    label: '直播',
  },
  {
    value: 4,
    label: '文档',
  },
]);
const categoryName = ref('');
const parentType = ref();

const sortName = () => {
  let params = {
    name: categoryName.value,
    type: parentType.value,
  };
  emitter.emit('createSortName', params);
};
const clear = () => {
  categoryName.value = '';
  parentType.value = '';
};
watch(
  () => props.visible,
  () => {
    !props.visible ? clear() : (parentType.value = props.menuType);
  }
);

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(aModal), {
      title: "添加分类",
      visible: props.visible,
      centered: props.centered,
      closable: props.closable,
      onCancel: props.close,
      onOk: props.ok
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createTextVNode(" 分类名称： "),
          _createVNode(_component_a_input, {
            class: "input_width",
            value: categoryName.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((categoryName).value = $event)),
            onChange: sortName,
            placeholder: "请输入分类名称",
            maxlength: 20,
            size: "small"
          }, {
            suffix: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, _toDisplayString(categoryName.value.length) + "/20", 1)
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(" 父集模块： "),
          _createVNode(_unref(aSelect), {
            class: "input_width",
            value: parentType.value,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((parentType).value = $event)),
            placeholder: "请输入父集模块",
            onChange: sortName
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (item) => {
                return (_openBlock(), _createBlock(_unref(aSelectOption), {
                  key: item.value,
                  value: item.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.label), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "centered", "closable", "onCancel", "onOk"])
  ]))
}
}

})